"use client";

import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useFormikContext } from "formik";
import { ButtonHTMLAttributes, DetailedHTMLProps } from "react";

import {
  type CommonButtonProps,
  createButtonClassNames,
  determineIcon,
} from "./common-button-resources";
import { SimpleButton } from "./simple-button";

type FormButtonProps = CommonButtonProps &
  DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement>;

export function FormButton({
  chevron,
  children,
  className,
  color,
  componentStyle,
  iconRight,
  size,
  text,
  type,
  variant,
  ...rest
}: FormButtonProps) {
  const classNames = createButtonClassNames({
    className,
    color,
    componentStyle,
    iconRight,
    size,
    variant,
  });

  let icon = determineIcon({ chevron, iconRight });

  let buttonText = text || "Continue";

  // assign to a variable instead of destructuring so that unit tests can function
  const formikContext = useFormikContext<any>();

  if (formikContext?.values.submitMethod === "submit") {
    buttonText = "Submit";
  }

  if (formikContext?.isSubmitting) {
    icon = <FontAwesomeIcon icon={faSpinner} spin />;
  }

  return (
    <SimpleButton
      iconRight={icon}
      text={buttonText}
      className={classNames}
      type={type || "submit"}
      {...rest}
    />
  );
}
